<template>
  <article class="iv-appraising-declare iv-p-t-24 iv-p-b-40">
    <div class="iv-main-width">
      <Tab v-model="tabName" :navList="navList" @on-click="handleClickTab"></Tab>
      <div v-show="tabName === 'myVoiceAdvice'">
        <VoicePanel title="心声建议">
          <template #operate>
            <section class="advice-btn__wrapper" @click="handleClickVoiceSubmit">
              <Iconfont type="check-circle" style="font-size:18px;color:#009AD8;"></Iconfont>
              <span class="text">心声提交</span>
            </section>
          </template>
        </VoicePanel>
        <List
          type="voiceAdvice"
          v-if="list.length"
          :showPage="true" 
          :map="map" 
          :total="total" 
          :list="list"
          :current="currentPage"
          :pageSize="pageSize"
          class="iv-m-t-24" 
          @on-detail="onDetailPage" 
          @on-change="onChangePage"
          @on-page-size-change="onChangePageSize">
        </List>
        <NoData v-if="!list.length"></NoData>
      </div>
      <div v-show="tabName === 'voiceAdviceSquare'">
        <VoicePanel title="心声建议"></VoicePanel>
        <List
          type="voiceAdvice"
          v-if="voiceList.length"
          :showPage="true" 
          :map="map" 
          :total="voiceTotal" 
          :list="voiceList"
          :current="voiceCurrentPage"
          :pageSize="voicePageSize"
          class="iv-m-t-24" 
          @on-detail="onDetailPublicPage" 
          @on-change="onChangePublicPage"
          @on-page-size-change="onChangePublicPageSize">
        </List>
        <NoData v-if="!voiceList.length"></NoData>
      </div>
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </article>
</template>

<script>
import Tab from '@/components/tab'
import NoData from '@/components/no-data'
import List from '../advice-list'
import VoicePanel from '../components/panel.vue'
import Iconfont from '@/components/iconfont/index.vue'
import { timeFormat } from '@/utils'
export default {
  name: 'VoiceAdviceList',
  components: {
    Tab,
    List,
    NoData,
    VoicePanel,
    Iconfont
  },
  data () {
    return {
      userId: sessionStorage.getItem('userId'),
      handleState: [
        {
          value: 'draft',
          label: '草稿'
        },
        {
          value: 'waitReceive',
          label: '待接收'
        },
        {
          value: 'waitHandle',
          label: '待处理'
        },
        {
          value: 'handling',
          label: '正在处理'
        },
        {
          value: 'waitAudit',
          label: '待审核'
        },{
          value: 'finish',
          label: '已完成'
        }
      ],
      getTypeCodesOptionList: [],
      list: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      voiceList: [],
      voiceCurrentPage: 1,
      voicePageSize: 5,
      voiceTotal: 0,
      infoState: 'SBZT02',
      paramsKey: 'infoState',
      spinShow: false,
      tabName: 'myVoiceAdvice',
      navList: [
        {
          label: '我的心声建议',
          name: 'myVoiceAdvice'
        }, 
        {
          label: '心声建议广场',
          name: 'voiceAdviceSquare'
        }
      ],
      map: {
        title: 'title',
        orgName: 'adviceTime',
        publishDate: 'handleState',
        endDate: 'typeCodes'
      }
    }
  },
  created () {
    this.getTypeCodesList()
    this.currentPage = Number(this.$route.query.currentPage) || 1
    this.voiceCurrentPage = Number(this.$route.query.voiceCurrentPage) || 1
    this.tabName = this.$route.query.tabName || 'myVoiceAdvice'
    this.handleClickTab(this.tabName, 'create')
  },
  methods: {
    // 列表查询心声建议
    getlist(isPublic, handleState, name) {
      this.spinShow = true
      this.list = []
      this.$ajax({
        url: 'api-general/module/portal/voiceAdvice/list',
        method: 'GET',
        data:{
          userId: this.userId,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          isPublic,
          handleState
        }
      }).then(data => {
        let res = data.data.data
        res.forEach(item => {
          let res =  Object.keys(item)
          res.forEach(element => {
            if(element == 'adviceTime') {
              item[element] = timeFormat(item[element])
            }
          })
          if(item.typeCodes.length > 0) {
            this.getTypeCodesOptionList.forEach(option => {
              for(let index in item.typeCodes) {
                if(item.typeCodes[index] == option.value) {
                  if(item.typeCodes[index] == 'X04') {
                    item.typeCodes[index] = item.otherTypeDesc
                  } else {
                    item.typeCodes[index] = option.label
                  }
                   
                }
              }
            })
          } else {
            item.typeCodes = ' '
          }
          this.handleState.forEach(res1 => {
            if(item.handleState == res1.value) {
              if(item.handleState == 'waitHandle' || item.handleState == 'handling' || item.handleState == 'waitAudit') {
                item.handleState = '正在处理'
              } else {
                item.handleState = res1.label
              }
            }
          })
          this.list.push(item)
        })
        this.total = data.data.count
        this.spinShow = false
      })
    },
    getPublicList() {
      this.spinShow = true
      this.voiceList = []
      this.$ajax({
        url: 'api-general/module/portal/voiceAdvice/list',
        method: 'GET',
        data:{
          currentPage: this.voiceCurrentPage,
          pageSize: this.voicePageSize,
          isPublic: 'yes',
          handleState: 'finish'
        }
      }).then(data => {
        let res = data.data.data
        res.forEach(item => {
          let res =  Object.keys(item)
          res.forEach(element => {
            if(element == 'adviceTime') {
              item[element] = timeFormat(item[element])
            }
          })
          if(item.typeCodes.length > 0) {
            this.getTypeCodesOptionList.forEach(option => {
              for(let index in item.typeCodes) {
                if(item.typeCodes[index] == option.value) {
                  if(item.typeCodes[index] == 'X04') {
                    item.typeCodes[index] = item.otherTypeDesc
                  } else {
                    item.typeCodes[index] = option.label
                  }
                   
                }
              }
            })
          } else {
            item.typeCodes = ' '
          }
          this.handleState.forEach(res1 => {
            if(item.handleState == res1.value) {
              if(item.handleState == 'waitHandle' || item.handleState == 'handling' || item.handleState == 'waitAudit') {
                item.handleState = '正在处理'
              } else {
                item.handleState = res1.label
              }
            }
          })
          this.voiceList.push(item)
        })
        this.voiceTotal = data.data.count
        this.spinShow = false
      })
    },
    // 删除心声建议
    deleteVoiceAdvice (voiceAdviceId) {
      this.$ajax({
        url: 'api-general/module/portal/voiceAdvice/delete',
        method: 'DELETE',
        data: {
          voiceAdviceId: voiceAdviceId
        }
      }).then(data => {
        this.$Message.success('删除成功')
        this.getlist()
      })
    },
    handleClickVoiceSubmit () {
      this.$router.push({ 
        name: 'createVoiceAdvice',
        query: {
          type: 'add',
          currentPage: this.currentPage,
          voiceCurrentPage: this.voiceCurrentPage,
          tabName: this.tabName
        }
      })
    },
    onDetailPage (item, name) {
      if(name == 'detail') {
        if(item.handleState != "草稿") {
          this.$router.push({
            name: 'createVoiceAdvice',
            query: {
              type: 'see',
              handleState: item.handleState,
              voiceAdviceId: item.voiceAdviceId,
              currentPage: this.currentPage,
              voiceCurrentPage: this.voiceCurrentPage,
              tabName: this.tabName
            }
          })
        } else {
          this.$router.push({
            name: 'createVoiceAdvice',
            query:{
              type: 'edit',
              handleState: item.handleState,
              voiceAdviceId: item.voiceAdviceId,
              currentPage: this.currentPage,
              voiceCurrentPage: this.voiceCurrentPage,
              tabName: this.tabName
            }
          })
        }
      } else if(name == 'delete') {
        this.deleteVoiceAdvice(item.voiceAdviceId)
      } else if(name == 'viewResult') {
        this.$router.push({
          name: 'viewResult',
          query:{
            handleState: item.handleState,
            voiceAdviceId: item.voiceAdviceId,
            currentPage: this.currentPage,
            voiceCurrentPage: this.voiceCurrentPage,
            tabName: this.tabName
          }
        })
      }
    },
    onDetailPublicPage (item) {
      this.$router.push({
        name: 'viewResult',
        query:{
          handleState: item.handleState,
          voiceAdviceId: item.voiceAdviceId,
          currentPage: this.currentPage,
          voiceCurrentPage: this.voiceCurrentPage,
          tabName: this.tabName
        }
      })
    },
    getTypeCodesList() {
      this.$ajax({
        url: 'api-general/module/portal/user/outGetList',
        method: 'GET',
        data: {
          dictCode: 'GG68',
          merge: false,
          bizLineCode: 'YWX03'
        }
      }).then(res => {
        res.data.data.forEach(item => {
          this.getTypeCodesOptionList.push({
            label: item.title,
            value: item.value
          })
        })
      })
    },
    handleClickTab (name, type) {
      this.tabName = name
      if (!type) {
        this.currentPage = 1
        this.voiceCurrentPage = 1
      }
      if (name === 'voiceAdviceSquare') {
        this.getPublicList()
      } else {
        this.getlist()
      }
    },
    onChangePage (page) {
      this.currentPage = page
      this.getlist()
    },
    onChangePageSize (page) {
      this.pageSize = page
      this.getlist()
    },
    onChangePublicPage (page) {
      this.voiceCurrentPage = page
      this.getPublicList()
    },
    onChangePublicPageSize (page) {
      this.voicePageSize = page
      this.getPublicList()
    }
  }
}
</script>

<style lang="scss" scoped>
.advice-btn__wrapper {
  width: 120px;
  height: 36px;
  border: 1px solid #009AD8;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .text {
    margin-left: 8px;
    font-size: 16px;
    font-weight: 500;
    color: #009AD8;
  }
}
.iv-appraising-declare {
  min-height: 100%;
  background-color: #fff;
}
</style>
